import "./App.css";
import "react-toastify/dist/ReactToastify.css";
//theme
import Theme from "./theme/theme";

//components
import Router from "./router/Router";
import { ChakraProvider } from "@chakra-ui/react";

function App() {
  return (
    <ChakraProvider theme={Theme}>
      <Router />
    </ChakraProvider>
  );
}

export default App;
